<div
  class="container-fluid"
  style="background-color: #252525; overflow-x: hidden; overflow-y: hidden"
>
  <div class="container-fluid" style="position: relative; height: 100vh">
    <img
      src="../../assets/svgs/pinkCircle.svg"
      class="translateY"
      data-speed="1.5"
      data-opacity="3"
      id="pink1"
      style="
        position: absolute;
        width: 500px;
        height: 500px;
        left: -250px;
        top: -50px;
      "
    />
    <img
      src="../../assets/svgs/greenCircle.svg"
      class="translateY"
      data-speed="0.2"
      data-opacity="3"
      id="green1"
      style="
        position: absolute;
        width: 500px;
        height: 500px;
        right: -300px;
        top: 200px;
      "
    />
    <img
      src="../../assets/svgs/goldCircle.svg"
      class="translateX translateY"
      data-speed="1.2"
      data-opacity="3"
      id="gold1"
      style="
        position: absolute;
        width: 700px;
        height: 700px;
        left: 0px;
        bottom: -500px;
      "
    />
    <!--<img src="../../assets/svgs/homemagdemylogo.svg" class="translateO d-none" data-opacity="5" id="logo" style="position: absolute;width: 50%;left:50vw;top:50vh;transform: translate(-50%,-50%);">-->
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="1146.728"
      height="257.655"
      viewBox="0 0 1146.728 257.655"
      class="translateO"
      data-opacity="5"
      id="logo"
      style="
        position: absolute;
        width: 50%;
        left: 50vw;
        top: 50vh;
        transform: translate(-50%, -50%);
      "
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          y1="0.5"
          x2="1"
          y2="0.5"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stop-color="#06d6a0" />
          <stop offset="1" stop-color="#00a99d" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-2"
          y1="0.5"
          x2="1"
          y2="0.5"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stop-color="#ffd166" />
          <stop offset="1" stop-color="#f15a24" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-3"
          y1="0.5"
          x2="1"
          y2="0.5"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stop-color="#ef476f" />
          <stop offset="1" stop-color="#9e005d" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-4"
          y1="0.5"
          x2="1"
          y2="0.5"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stop-color="#9e005d" />
          <stop offset="1" stop-color="#ef476f" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-5"
          y1="0.5"
          x2="1"
          y2="0.5"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stop-color="#00a99d" />
          <stop offset="1" stop-color="#06d6a0" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-6"
          y1="0.5"
          x2="1"
          y2="0.5"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stop-color="#f15a24" />
          <stop offset="1" stop-color="#ffd166" />
        </linearGradient>
      </defs>
      <g
        id="Group_11"
        data-name="Group 11"
        transform="translate(-171 -1007.739)"
      >
        <g
          id="Component_1_1"
          data-name="Component 1 – 1"
          transform="translate(171 1007.739)"
        >
          <g id="Group_7" data-name="Group 7">
            <g id="Group_1" data-name="Group 1">
              <path
                id="Path_1"
                class="logotext"
                data-name="Path 1"
                d="M314.077,436,290.84,483.686l-7.564,15.53-4.895,10.035L194.366,681.682V513.157c0-17.188,14.836-36.931,32.978-43.884Z"
                transform="translate(-27.3 -434.824)"
                fill="url(#linear-gradient)"
                stroke="#06D6A0"
                stroke-width="2"
              />
              <path
                id="Path_2"
                class="logotext"
                data-name="Path 2"
                d="M243.016,435l-23.236,47.685-7.564,15.53-4.894,10.037L123.3,680.681V512.156c0-17.188,14.836-36.931,32.978-43.884Z"
                transform="translate(-39.772 -435)"
                fill="url(#linear-gradient-2)"
                stroke="#FFD166"
                stroke-width="2"
              />
              <path
                id="Path_3"
                class="logotext"
                data-name="Path 3"
                d="M171.956,435,148.72,482.685l-7.566,15.53-4.894,10.037L52.244,680.681V512.156c0-17.188,14.836-36.931,32.978-43.884Z"
                transform="translate(-52.244 -435)"
                fill="url(#linear-gradient-3)"
                stroke="#EF476F"
                stroke-width="2"
              />
            </g>
            <g
              id="Group_6"
              data-name="Group 6"
              transform="translate(324.968 35.131)"
            >
              <path
                class="logotext"
                id="Path_4"
                data-name="Path 4"
                d="M328.692,465h0a36.685,36.685,0,0,1,31.768,18.339l33.263,57.594h1.315l33.612-57.682A36.756,36.756,0,0,1,460.407,465h.055V598.583h0A21.177,21.177,0,0,1,439.286,577.4v-50.8l1.132-22.147h-1.132l-35.3,60.436a11,11,0,0,1-9.5,5.45h0a11,11,0,0,1-9.506-5.47L349.87,504.461h-1.132l1.132,22.147v50.8a21.178,21.178,0,0,1-21.178,21.178h0Z"
                transform="translate(-328.692 -464.866)"
                fill="#fff"
                stroke="#fff"
                stroke-width="5"
              />
              <g
                id="Group_2"
                data-name="Group 2"
                transform="translate(148.022 40.06)"
              >
                <path
                  id="Path_5"
                  class="logotext"
                  data-name="Path 5"
                  d="M527.545,508.953q-11.207-9.989-31.72-9.988a52.354,52.354,0,0,0-22.2,4.529,42.227,42.227,0,0,0-16.377,13.413l1.578,1.036a24.592,24.592,0,0,0,24.106,1.471l.754-.377a28.449,28.449,0,0,1,12.518-2.681,24.969,24.969,0,0,1,8.283,1.388,23.9,23.9,0,0,1,7.059,3.882,18.294,18.294,0,0,1,4.894,6.013,18.555,18.555,0,0,1,1.93,7.588v3.518a78.959,78.959,0,0,0-9.553-3.236,57.416,57.416,0,0,0-15.436-1.765,54.076,54.076,0,0,0-15.425,2.13,38.75,38.75,0,0,0-12.33,6.012,27.3,27.3,0,0,0-8.093,9.624,30.071,30.071,0,0,0-.189,25.437,30.838,30.838,0,0,0,7.436,9.812,34.036,34.036,0,0,0,11.106,6.47,40.015,40.015,0,0,0,13.73,2.306q10.165,0,16.753-4.341a56.368,56.368,0,0,0,10.73-9.166h1.271v10.589a20,20,0,0,0,20-20V537.449C538.746,525.119,535.016,515.613,527.545,508.953Zm-11.39,54.955a25.874,25.874,0,0,1-13.46,12.671A24.72,24.72,0,0,1,493,578.521a21.747,21.747,0,0,1-6.305-.93,15.99,15.99,0,0,1-5.447-2.777,15.764,15.764,0,0,1-3.859-4.341,11.024,11.024,0,0,1-1.506-5.835q0-6.282,5.835-10.73,5.824-4.43,15.613-4.435A41.707,41.707,0,0,1,509,550.956a41.256,41.256,0,0,1,9.224,3.883A20.382,20.382,0,0,1,516.156,563.909Z"
                  transform="translate(-454.613 -498.965)"
                  fill="#fff"
                  stroke="#fff"
                  stroke-width="5"
                />
              </g>
              <g
                id="Group_3"
                data-name="Group 3"
                transform="translate(245.307 39.436)"
              >
                <path
                  class="logotext"
                  id="Path_6"
                  data-name="Path 6"
                  d="M632.083,587.5V522.118a20,20,0,0,0-20-20v10.589h-1.13a34.115,34.115,0,0,0-11.989-10.189,37.318,37.318,0,0,0-17.824-4.083,39.759,39.759,0,0,0-16.412,3.554,45.031,45.031,0,0,0-14.059,9.93,47.19,47.19,0,0,0-9.718,15.259,51.844,51.844,0,0,0-3.577,19.566,52.574,52.574,0,0,0,3.577,19.648,46.758,46.758,0,0,0,9.718,15.353,45.012,45.012,0,0,0,14.059,9.93,39.759,39.759,0,0,0,16.412,3.554,37.319,37.319,0,0,0,17.824-4.083,34.021,34.021,0,0,0,11.989-10.2h1.13v7.848s-2.377,15.884-7.2,20.848-11.576,7.46-20.235,7.46a25.345,25.345,0,0,1-15.06-4.542c-.047-.024-.082-.059-.129-.082a29.949,29.949,0,0,0-28.578-3.823l-.282.118a40.837,40.837,0,0,0,5.177,9.247,38.149,38.149,0,0,0,8.941,8.7,49.056,49.056,0,0,0,12.894,6.388,53.569,53.569,0,0,0,17.037,2.495,55.63,55.63,0,0,0,18.919-3.141,41.891,41.891,0,0,0,15.059-9.248,43.8,43.8,0,0,0,9.965-15.083A51.031,51.031,0,0,0,632.083,587.5ZM609.87,559.849a28.772,28.772,0,0,1-5.929,9.212,23.677,23.677,0,0,1-8.565,5.635,27.533,27.533,0,0,1-9.978,1.882,26.151,26.151,0,0,1-18.635-7.705,27.836,27.836,0,0,1-6.025-9.213,35.209,35.209,0,0,1,0-24.813,27.836,27.836,0,0,1,6.025-9.213A26.15,26.15,0,0,1,585.4,517.93a26.46,26.46,0,0,1,9.978,1.976,25.655,25.655,0,0,1,8.565,5.635,27.535,27.535,0,0,1,5.929,9.212,35.972,35.972,0,0,1,0,25.095Z"
                  transform="translate(-537.373 -498.434)"
                  fill="#fff"
                  stroke="#fff"
                  stroke-width="5"
                />
              </g>
              <g
                id="Group_4"
                data-name="Group 4"
                transform="translate(355.772)"
              >
                <path
                  class="logotext"
                  id="Path_7"
                  data-name="Path 7"
                  d="M722.959,464.886a17.951,17.951,0,0,0-17.954,17.954v24.413l1.118,12.518h-1.118a31.561,31.561,0,0,0-11.435-10.225q-7.7-4.323-18.365-4.329a40.232,40.232,0,0,0-16.778,3.6,42.984,42.984,0,0,0-13.965,10.035,49.544,49.544,0,0,0-9.565,15.2,53.952,53.952,0,0,0,0,38.507,49.543,49.543,0,0,0,9.565,15.2A42.985,42.985,0,0,0,658.427,597.8a40.221,40.221,0,0,0,16.778,3.589q10.677,0,18.365-4.329a31.351,31.351,0,0,0,11.435-10.225h1.141A11.762,11.762,0,0,0,717.912,598.6h8.271V464.886ZM703.488,565.537a27.968,27.968,0,0,1-5.929,9.154,25.753,25.753,0,0,1-8.659,5.741,27.04,27.04,0,0,1-10.26,2.035,26.762,26.762,0,0,1-10.353-2.035,25.3,25.3,0,0,1-8.566-5.823,29.477,29.477,0,0,1-5.929-9.165,34.135,34.135,0,0,1,0-24.425,29.569,29.569,0,0,1,5.929-9.154,25.3,25.3,0,0,1,8.566-5.824,26.763,26.763,0,0,1,10.353-2.035,27.041,27.041,0,0,1,10.26,2.035,25.9,25.9,0,0,1,8.659,5.729,28.146,28.146,0,0,1,5.929,9.165,34.615,34.615,0,0,1,0,24.6Z"
                  transform="translate(-631.344 -464.886)"
                  fill="#fff"
                  stroke="#fff"
                  stroke-width="5"
                />
              </g>
              <g
                id="Group_5"
                data-name="Group 5"
                transform="translate(464.259 39.813)"
              >
                <path
                  class="logotext"
                  id="Path_8"
                  data-name="Path 8"
                  d="M812.765,527.25a42.83,42.83,0,0,0-8.941-15.177,40.59,40.59,0,0,0-14.212-9.8,49.067,49.067,0,0,0-19.107-3.517,46.43,46.43,0,0,0-19.2,3.883A45.24,45.24,0,0,0,736.527,513.1a47.27,47.27,0,0,0-9.506,15.353,53.371,53.371,0,0,0,.188,37.92,46.481,46.481,0,0,0,9.978,15.271,45.442,45.442,0,0,0,15.154,10.082,49.73,49.73,0,0,0,19.106,3.6q15.619,0,26.355-7.024a49.732,49.732,0,0,0,16.565-17.578l-1.224-.588A25.393,25.393,0,0,0,787,572.487l-.117.082q-5.842,4.255-14.872,4.26a30.62,30.62,0,0,1-9.224-1.484,25.647,25.647,0,0,1-8.565-4.623,26.508,26.508,0,0,1-6.495-7.953,7.636,7.636,0,0,1,6.706-11.294h61.061a5.8,5.8,0,0,1,.189-1.471c0-.223.012-.447.035-.693.082-.871.153-1.754.153-2.636A58.425,58.425,0,0,0,812.765,527.25Zm-52.543,8.93c-7.412,0-10.93-9.33-5.211-14.036a1.24,1.24,0,0,0,.129-.106,23.855,23.855,0,0,1,15.53-5.283,27.694,27.694,0,0,1,11.2,2.035,25.292,25.292,0,0,1,7.53,4.907,19.07,19.07,0,0,1,4.329,6.294,25.34,25.34,0,0,1,1.788,6.189Z"
                  transform="translate(-723.633 -498.755)"
                  fill="#fff"
                  stroke="#fff"
                  stroke-width="5"
                />
              </g>
              <path
                class="logotext"
                id="Path_9"
                data-name="Path 9"
                d="M816.109,502h6.007a11.765,11.765,0,0,1,11.766,11.765h1.145a32.943,32.943,0,0,1,12.21-10.517,35.264,35.264,0,0,1,16.6-4.1q10.491,0,18.031,4.547a27.3,27.3,0,0,1,10.97,11.854,39.545,39.545,0,0,1,12.783-11.676q8.014-4.72,19.27-4.724a39.093,39.093,0,0,1,14.882,2.585,27.684,27.684,0,0,1,10.4,7.22,30.961,30.961,0,0,1,6.2,11.142,47.225,47.225,0,0,1,2.1,14.528v54.726H947.879a10.589,10.589,0,0,1-10.589-10.589V539.063q0-11.516-4.487-16.109t-13.094-4.59a18.145,18.145,0,0,0-8.882,2.161,20.624,20.624,0,0,0-6.684,5.849,27.408,27.408,0,0,0-4.213,8.549,35.327,35.327,0,0,0-1.465,10.261V592.69h-.283A20.894,20.894,0,0,1,877.289,571.8V539.249q0-11.81-4.789-16.521t-13.8-4.707a17.7,17.7,0,0,0-8.827,2.216,21.52,21.52,0,0,0-6.76,6A28.11,28.11,0,0,0,838.789,535a36.142,36.142,0,0,0-1.5,10.522v47.125H837a20.894,20.894,0,0,1-20.894-20.895Z"
                transform="translate(-243.144 -458.873)"
                fill="#fff"
                stroke="#fff"
                stroke-width="5"
              />
              <path
                class="logotext"
                id="Path_10"
                data-name="Path 10"
                d="M983.145,586.99l-38.456-85.6h0a35.256,35.256,0,0,1,32.475,21.531l16.348,38.685h.943l15.9-38.763a34.569,34.569,0,0,1,31.984-21.453h0L993.463,611.855A34.164,34.164,0,0,1,962.221,632.2h0Z"
                transform="translate(-220.576 -458.479)"
                fill="#fff"
                stroke="#fff"
                stroke-width="5"
              />
            </g>
          </g>
          <circle
            class="logoelse"
            id="Ellipse_1"
            data-name="Ellipse 1"
            cx="10.825"
            cy="10.825"
            r="10.825"
            transform="translate(662.276 229.477)"
            fill="url(#linear-gradient-4)"
          />
          <circle
            class="logoelse"
            id="Ellipse_2"
            data-name="Ellipse 2"
            cx="10.825"
            cy="10.825"
            r="10.825"
            transform="translate(1034.936 229.477)"
            fill="url(#linear-gradient-5)"
          />
          <g
            id="Group_8"
            class="logoelse"
            data-name="Group 8"
            transform="translate(853.121 224.923)"
          >
            <path
              id="Path_11"
              data-name="Path 11"
              d="M799.583,649.91l3.25,3.785-4.443,3.414-2.22-2.55a10.476,10.476,0,0,1-3.229,1.892,11.342,11.342,0,0,1-3.93.657,12.55,12.55,0,0,1-4.36-.741,10.439,10.439,0,0,1-3.5-2.1,9.726,9.726,0,0,1-2.324-3.25,10.194,10.194,0,0,1-.843-4.2,9.729,9.729,0,0,1,1.152-4.607,11.52,11.52,0,0,1,3.249-3.785,10.142,10.142,0,0,1-1.151-2.118,6.279,6.279,0,0,1-.453-2.366,8.064,8.064,0,0,1,.555-3,6.75,6.75,0,0,1,1.6-2.406,7.936,7.936,0,0,1,2.489-1.6,8.427,8.427,0,0,1,3.25-.6,8.65,8.65,0,0,1,4.977,1.3,7.17,7.17,0,0,1,2.715,3.517l-4.9,2.592a3.335,3.335,0,0,0-1.029-1.563,2.506,2.506,0,0,0-1.646-.576,2.068,2.068,0,0,0-1.645.658,2.187,2.187,0,0,0-.576,1.481,2.285,2.285,0,0,0,.267,1.11,6.655,6.655,0,0,0,.844,1.152l8.391,9.832,2.3-3.744,4.4,2.756Zm-10.16,1.646a4.809,4.809,0,0,0,3.208-1.11l-6.87-7.981a5.655,5.655,0,0,0-1.769,4.072,4.755,4.755,0,0,0,.453,2.118,4.673,4.673,0,0,0,1.214,1.563,5.589,5.589,0,0,0,1.748.988A6.008,6.008,0,0,0,789.424,651.556Z"
              transform="translate(-777.987 -626.34)"
              fill="url(#linear-gradient-6)"
            />
          </g>
          <g
            id="Group_9"
            class="logoelse"
            data-name="Group 9"
            transform="translate(697.638 222.96)"
          >
            <path
              id="Path_12"
              data-name="Path 12"
              d="M645.719,658.559v-33.57h12.143a9.772,9.772,0,0,1,6.845,2.626,8.4,8.4,0,0,1,2.861,6.517,7.087,7.087,0,0,1-4.548,6.986v.187a8.163,8.163,0,0,1,4.126,2.93,7.786,7.786,0,0,1,1.547,4.758,8.84,8.84,0,0,1-3,6.845,10.1,10.1,0,0,1-7.173,2.72Zm4.314-29.444v10.268h7.829a5.223,5.223,0,0,0,3.845-1.547,4.985,4.985,0,0,0,.047-7.174,4.958,4.958,0,0,0-3.7-1.547Zm0,14.3v11.018h8.673a5.525,5.525,0,0,0,5.58-5.532,5.269,5.269,0,0,0-1.641-3.845,5.6,5.6,0,0,0-4.126-1.641Z"
              transform="translate(-645.719 -624.614)"
              fill="#fff"
            />
            <path
              id="Path_13"
              data-name="Path 13"
              d="M679.283,657.839a10.988,10.988,0,0,1-8.345-3.47,12.244,12.244,0,0,1-3.282-8.767,12.478,12.478,0,0,1,3.188-8.745,11.463,11.463,0,0,1,16.293-.187q3.024,3.3,3.023,9.26l-.047.469h-18.05a7.487,7.487,0,0,0,2.25,5.439,7.2,7.2,0,0,0,5.158,2.062q4.124,0,6.47-4.125l3.845,1.875A11.454,11.454,0,0,1,685.5,656.2,11.873,11.873,0,0,1,679.283,657.839Zm-6.892-15h13.175a5.729,5.729,0,0,0-1.946-3.963,6.819,6.819,0,0,0-4.713-1.57,6.247,6.247,0,0,0-4.2,1.5A7.16,7.16,0,0,0,672.391,642.836Z"
              transform="translate(-641.869 -623.144)"
              fill="#fff"
            />
            <path
              id="Path_14"
              data-name="Path 14"
              d="M694.464,624.989v33.57H690.15v-33.57Z"
              transform="translate(-637.921 -624.614)"
              fill="#fff"
            />
            <path
              id="Path_15"
              data-name="Path 15"
              d="M703.943,627.718a3.042,3.042,0,1,1-.891-2.157A2.934,2.934,0,0,1,703.943,627.718Zm-.891,7.923v22.974h-4.313V635.641Z"
              transform="translate(-636.57 -624.67)"
              fill="#fff"
            />
            <path
              id="Path_16"
              data-name="Path 16"
              d="M717.372,657.839a10.988,10.988,0,0,1-8.345-3.47,12.249,12.249,0,0,1-3.282-8.767,12.483,12.483,0,0,1,3.188-8.745,11.464,11.464,0,0,1,16.293-.187q3.024,3.3,3.025,9.26l-.047.469H710.152a7.483,7.483,0,0,0,2.251,5.439,7.2,7.2,0,0,0,5.157,2.062q4.124,0,6.47-4.125l3.845,1.875a11.455,11.455,0,0,1-4.291,4.548A11.87,11.87,0,0,1,717.372,657.839Zm-6.892-15h13.175a5.724,5.724,0,0,0-1.945-3.963A6.815,6.815,0,0,0,717,637.3a6.249,6.249,0,0,0-4.2,1.5A7.167,7.167,0,0,0,710.48,642.836Z"
              transform="translate(-635.184 -623.144)"
              fill="#fff"
            />
            <path
              id="Path_17"
              data-name="Path 17"
              d="M739.364,656.977H735.05L725.767,634h4.689l6.751,17.816h.094L744.146,634h4.6Z"
              transform="translate(-631.669 -623.032)"
              fill="#fff"
            />
            <path
              id="Path_18"
              data-name="Path 18"
              d="M757.616,657.839a10.988,10.988,0,0,1-8.346-3.47,12.249,12.249,0,0,1-3.282-8.767,12.483,12.483,0,0,1,3.188-8.745,11.463,11.463,0,0,1,16.293-.187q3.024,3.3,3.025,9.26l-.047.469H750.4a7.483,7.483,0,0,0,2.251,5.439A7.2,7.2,0,0,0,757.8,653.9q4.124,0,6.47-4.125l3.845,1.875a11.456,11.456,0,0,1-4.291,4.548A11.869,11.869,0,0,1,757.616,657.839Zm-6.893-15H763.9a5.723,5.723,0,0,0-1.945-3.963,6.815,6.815,0,0,0-4.713-1.57,6.251,6.251,0,0,0-4.2,1.5A7.174,7.174,0,0,0,750.723,642.836Z"
              transform="translate(-628.12 -623.144)"
              fill="#fff"
            />
          </g>
          <g
            id="Group_10"
            class="logoelse"
            data-name="Group 10"
            transform="translate(894.373 223.148)"
          >
            <path
              id="Path_19"
              data-name="Path 19"
              d="M832.679,624.83v4.126H817.4V639.6h13.783v4.032H817.4v10.642h15.284V658.4h-19.6V624.83Z"
              transform="translate(-813.08 -624.83)"
              fill="#fff"
            />
            <path
              id="Path_20"
              data-name="Path 20"
              d="M844.785,656.817h-4.314l-9.283-22.973h4.689l6.751,17.816h.094l6.845-17.816h4.6Z"
              transform="translate(-809.902 -623.248)"
              fill="#fff"
            />
            <path
              id="Path_21"
              data-name="Path 21"
              d="M851.41,645.443a12.15,12.15,0,0,1,3.329-8.768,11.346,11.346,0,0,1,8.486-3.469,11.2,11.2,0,0,1,8.439,3.469,13.076,13.076,0,0,1,0,17.535,11.2,11.2,0,0,1-8.439,3.469,11.342,11.342,0,0,1-8.486-3.469A12.145,12.145,0,0,1,851.41,645.443Zm4.313,0a8.411,8.411,0,0,0,2.157,6,7.368,7.368,0,0,0,10.69,0,9.367,9.367,0,0,0,0-11.956,7.266,7.266,0,0,0-10.69,0A8.35,8.35,0,0,0,855.723,645.443Z"
              transform="translate(-806.353 -623.36)"
              fill="#fff"
            />
            <path
              id="Path_22"
              data-name="Path 22"
              d="M878.976,624.83V658.4h-4.313V624.83Z"
              transform="translate(-802.271 -624.83)"
              fill="#fff"
            />
            <path
              id="Path_23"
              data-name="Path 23"
              d="M894.321,656.817h-4.313l-9.283-22.973h4.689l6.751,17.816h.094l6.845-17.816H903.7Z"
              transform="translate(-801.207 -623.248)"
              fill="#fff"
            />
            <path
              id="Path_24"
              data-name="Path 24"
              d="M912.573,657.679a10.987,10.987,0,0,1-8.345-3.469,12.244,12.244,0,0,1-3.282-8.767,12.476,12.476,0,0,1,3.188-8.745,11.463,11.463,0,0,1,16.293-.187q3.024,3.3,3.023,9.26l-.046.469H905.353a7.48,7.48,0,0,0,2.251,5.438,7.2,7.2,0,0,0,5.157,2.063q4.126,0,6.47-4.126l3.845,1.876a11.467,11.467,0,0,1-4.289,4.548A11.876,11.876,0,0,1,912.573,657.679Zm-6.891-15h13.174a5.719,5.719,0,0,0-1.946-3.961,6.817,6.817,0,0,0-4.713-1.57,6.257,6.257,0,0,0-4.2,1.5A7.163,7.163,0,0,0,905.682,642.676Z"
              transform="translate(-797.658 -623.36)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div
    class="container-fluid"
    style="position: relative; height: 100vh; top: -200px"
  >
    <p
      data-aos="fade-right"
      data-aos-offset="500"
      class="container"
      style="
        font-size: 35px;
        color: orangered;
        font-weight: 700;
        border-bottom: 3px solid orange;
        margin-top: 50px;
      "
    >
      DOMAINS
    </p>
    <div class="container" >
      <div class="row" style="margin-top: 100px" style="justify-content: center;margin-top: 100px;">
        <div class="col-md-4">
          <div
            class="container neumorph Card card"
            data-aos="fade-left"
            data-aos-offset="400"
            (click)="goToUrl('http://magdemy.github.io/Brochure')"
          >
            <p class="card-text">UX</p>
            <!--<a href="" class="card-link">More<img src="../../assets/icons/chevron_right.svg"></a>-->
          </div>
        </div>
        <div class="col-md-4">
          <div
            class="container neumorph Card card"
            data-aos="fade-right"
            data-aos-offset="400"
            (click)="goToUrl('http://magdemy.github.io/Brochure')"
          >
            <p class="card-text">UI</p>
            <!--<a href="" class="card-link">More<img src="../../assets/icons/chevron_right.svg"></a>-->
          </div>
        </div>
        <div class="col-md-4 d-none">
          <div
            class="container neumorph Card card"
            data-aos="fade-right"
            data-aos-offset="400"
          >
            <p class="card-text">DM</p>
            <!--<a href="" class="card-link">More<img src="../../assets/icons/chevron_right.svg"></a>-->
          </div>
        </div>
      </div>
      <div class="row" style="margin-top: 100px">
        <div class="col-md-4">
          <div
            class="container neumorph Card card"
            data-aos="fade-left"
            data-aos-offset="200"
            (click)="goToUrl('http://magdemy.github.io/Brochure')"
          >
            <p class="card-text">FRONT END</p>
            <!--<a href="" class="card-link">More<img src="../../assets/icons/chevron_right.svg"></a>-->
          </div>
        </div>
        <div class="col-md-4">
          <div
            class="container neumorph Card card"
            data-aos="fade-down"
            data-aos-offset="200"
            (click)="goToUrl('http://magdemy.github.io/Brochure')"
          >
            <p class="card-text">BACK END</p>
            <!--<a href="" class="card-link">More<img src="../../assets/icons/chevron_right.svg"></a>-->
          </div>
        </div>
        <div class="col-md-4">
          <div
            class="container neumorph Card card"
            data-aos="fade-right"
            data-aos-offset="200"
            (click)="goToUrl('http://magdemy.github.io/Brochure')"
          >
            <p class="card-text">MOBILE APP</p>
            <!--<a href="" class="card-link">More<img src="../../assets/icons/chevron_right.svg"></a>-->
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="container-fluid"
    style="
      position: relative;
      height: 100vh;
      top: -200px;
      
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    "
  >
    <div class="main-ring" style="position: relative" data-aos="fade-right" data-aos-offset="200">
      <div
        (mouseenter)="toggletab('mobile')"
        [ngClass]="{ 'tab-ring': true, active: currentTab == 'mobile' }"
        style="top: 0px; left: 50%; transform: translate(-50%, -50%)"
      >
        <img
          *ngIf="currentTab != 'mobile'"
          src="../../assets/icons/mobile.svg"
          style="width: 60px; height: 60px"
        />
        <img
          *ngIf="currentTab == 'mobile'"
          src="../../assets/icons/mobile-white.svg"
          style="width: 60px; height: 60px"
        />
      </div>
      <div
        (mouseenter)="toggletab('backend')"
        [ngClass]="{ 'tab-ring': true, active: currentTab == 'backend' }"
        style="top: 25%; left: 0px; transform: translate(0%, -50%)"
      >
        <img
          *ngIf="currentTab != 'backend'"
          src="../../assets/icons/backend.svg"
          style="width: 60px; height: 60px"
        />
        <img
          *ngIf="currentTab == 'backend'"
          src="../../assets/icons/backend-white.svg"
          style="width: 60px; height: 60px"
        />
      </div>
      <div
        (mouseenter)="toggletab('frontend')"
        [ngClass]="{ 'tab-ring': true, active: currentTab == 'frontend' }"
        style="top: 75%; left: 0px; transform: translate(0%, -50%)"
      >
        <img
          *ngIf="currentTab != 'frontend'"
          src="../../assets/icons/frontend.svg"
          style="width: 60px; height: 60px"
        />
        <img
          *ngIf="currentTab == 'frontend'"
          src="../../assets/icons/frontend-white.svg"
          style="width: 60px; height: 60px"
        />
      </div>
      <div
        (mouseenter)="toggletab('fsdev')"
        [ngClass]="{ 'tab-ring': true, active: currentTab == 'fsdev' }"
        style="top: 25%; left: 100%; transform: translate(-100%, -50%)"
      >
        <img
          *ngIf="currentTab != 'fsdev'"
          src="../../assets/icons/fsdev.svg"
          style="width: 50px; height: 50px"
        />
        <img
          *ngIf="currentTab == 'fsdev'"
          src="../../assets/icons/fsdev-white.svg"
          style="width: 50px; height: 50px"
        />
      </div>
      <div
        (mouseenter)="toggletab('dedev')"
        [ngClass]="{ 'tab-ring': true, active: currentTab == 'dedev' }"
        style="top: 75%; left: 100%; transform: translate(-100%, -50%)"
      >
        <img
          *ngIf="currentTab != 'dedev'"
          src="../../assets/icons/dedev.svg"
          style="width: 60px; height: 60px"
        />
        <img
          *ngIf="currentTab == 'dedev'"
          src="../../assets/icons/dedev-white.svg"
          style="width: 60px; height: 60px"
        />
      </div>
      <div
        (mouseenter)="toggletab('design')"
        [ngClass]="{ 'tab-ring': true, active: currentTab == 'design' }"
        style="top: 100%; left: 50%; transform: translate(-50%, -50%)"
      >
        <img
          *ngIf="currentTab != 'design'"
          src="../../assets/icons/design.svg"
          style="width: 60px; height: 60px"
        />
        <img
          *ngIf="currentTab == 'design'"
          src="../../assets/icons/design-white.svg"
          style="width: 60px; height: 60px"
        />
      </div>
      <div
        style="
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          position: relative;
          text-align: center;
          max-width: 500px;
        "
      >
        <p class="text" style="color: #c72566">{{ currentTitle }}</p>
      </div>
    </div>
    <div
      style="
        height: 500px;
        width: 500px;
        margin-left: 50px;
        padding: 0px 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      "
       data-aos="fade-left" data-aos-offset="200"
    >
      <!--<p style="color: #c72566; font-size: 40px;margin-bottom: 20px;">Description</p>-->
      <p style="color: white; text-align: center; font-size: 22px;margin-bottom: 40px;">
        {{ currentDescription }}
      </p>
      <div class="container" style="display: flex;flex-direction: row;justify-content: space-between;align-items: center;max-width: 500px;">
        <button type="button" class="btn" id="btn1"style="width: 200px;color: #c72566;padding: 10px;border: 1px solid #c72566;font-weight: 400;font-size: 18px;pointer-events:all;"  data-bs-toggle="modal" data-bs-target="#exampleModalCenter" (click)="toggler(0)">Book A Demo</button>
        <button type="button" class="btn" id="btn2"style="width: 200px;color: #252525;background-color: #c72566;padding: 10px;border: 1px solid #c72566;font-weight: 600;font-size: 18px;" data-bs-toggle="modal" data-bs-target="#exampleModalCenter" (click)="toggler(1)">Register</button>
      </div>
    </div>
  </div>
  <div
    style="
      position: relative;
      height: 50vh;
      margin-top: -200px;
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    "
  >
    <img
      src="../../assets/svgs/contact.svg"
      style="width: 100%; position: absolute; bottom: 0px"
    />
    <div
      class="container"
      style="
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 500px;
        background-color: #252525;
        z-index: 2;
        height: inherit;
      "
    >
      <p style="font-size: 32px; font-weight: 500; color: #2dc99f">Magdemy</p>
      <p style="color: white">For Enquiries feel free to contact us</p>
      <div
        style="
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          margin-bottom: 20px;
        "
      >
        <img
          src="../../assets/icons/mobileicon.svg"
          style="height: 30px; margin-right: 10px"
        />
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
          "
        >
          <p style="color: white; margin-bottom: 5px">+91 96008 08174</p>
        </div>
      </div>
      <div
        style="
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          margin-bottom: 20px;
        "
      >
        <img
          src="../../assets/icons/mailicon.svg"
          style="height: 20px; margin-right: 10px"
        />
        <p style="color: white; margin-bottom: 0px">winbig@magdemy.com</p>
      </div>
      <!-- <div
        style="
          width: 150px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          pointer-events: all;
        "
        id="footericonbar"
      >
        <a href="https://www.facebook.com/magdemy.edu" target="_blank"
          ><img src="../../assets/icons/fbicon.svg"
        /></a>
        <a href="https://twitter.com/magdemy" target="_blank"
          ><img src="../../assets/icons/tweeticon.svg"
        /></a>
        <a href="https://www.instagram.com/magdemy_edu/" target="_blank"
          ><img src="../../assets/icons/instaicon.svg"
        /></a>
        <a href="https://www.linkedin.com/company/magdemy" target="_blank"
          ><img src="../../assets/icons/liicon.svg"
        /></a>
      </div> -->
    </div>
  </div>
</div>





  <!-- Modal 3 -->
  <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" style="backdrop-filter: blur(5px);">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document" >
      <div class="modal-content"style="border: 0px;">
        <div class="modal-header" style="padding: 0px;background-color: #252525;">
          <div class="modal-title" id="exampleModalLongTitle" style="height: 150px; display: flex;flex-direction: column;justify-content: center;align-items: center;width: 100%;">
            <p style="font-size: 40px;font-weight: bolder;color: orangered;text-align: center;">{{model[modelId].modelTitle}}</p>
            <p style="text-align: center;color: white;">Fill-up the form and our team will revert to you within 24 hours.</p>
          </div>
          <button type="button" class="btn close" data-bs-dismiss="modal" data-bs-target="#newModelCenter" aria-label="Close" style="position: absolute;right: 20px;top: 10px;">
            <span aria-hidden="true" style="font-size: 30px;color: white;">&times;</span>
          </button>
        </div>
        <div class="modal-body" style="overflow-y: scroll;max-height: 500px;background-color: #252525;">

          <div class="cust-row" *ngIf="modelId==1">
            <div class="form-group">
                <label class="form-label">Course</label>
                <input type="text" [(ngModel)]="currentTitle" autocomplete="off"  value="currentTitle" name="comment" class="form-control" placeholder="Your Course..." disabled>
            </div>
          </div>

          <div class="cust-row">
            <div class="form-group">
                <label class="form-label">First Name</label>
                <input type="text" [(ngModel)]="firstname" style="background-color:#252525;" autocomplete="off" value="firstname" name="firstname" class="form-control small" placeholder="John" (change)="validatefname()">
                <small *ngIf="fnvalid==false" class="form-text error-txt" style="color:red;">{{fnerrormsg}}</small>
            </div>

            <div class="form-group">
                <label class="form-label">Last Name</label>
                <input type="text" [(ngModel)]="lastname"  autocomplete="off" value="lastname" name="lastname" class="form-control small" placeholder="Bob" (change)="validatelname()">
                <small *ngIf="lnvalid==false" class="form-text error-txt" style="color:red;">{{lnerrormsg}}</small>
            </div>
          </div>

            <div class="cust-row">
              <div class="form-group">
                  <label class="form-label">E-mail</label>
                  <input type="email" [(ngModel)]="email" autocomplete="off"  value="email" name="email" class="form-control small" placeholder="johnbob@example.com" (change)="validateemail()">
                  <small *ngIf="evalid==false" class="form-text error-txt" style="color:red;">{{eerrormsg}}</small>
              </div>
              
              <div class="form-group">
                  <label class="form-label">Phone Number</label>
                  <input type="text" [(ngModel)]="phno"  autocomplete="off" value="phno" name="phno" class="form-control small" placeholder="+1234567890" (change)="validatefphone()">
                  <small *ngIf="pvalid==false" class="form-text error-txt" style="color:red;">{{perrormsg}}</small>
              </div>
            </div>

            <div class="cust-row">
              <div class="form-group">
                  <label class="form-label">Your message for us</label>
                  <input type="text" [(ngModel)]="comment" autocomplete="off"  value="comment" name="comment" class="form-control" placeholder="Write your message here...">
              </div>
            </div>
        
        </div>
        <div class="modal-footer" style="padding-right: 50px;background-color: #252525;">
          <button type="button" class="btn" id='button1' (click)='reset()'>Reset</button>
          <button type="button" class="btn" id='button2' (click)='resolver()'>{{model[modelId].btnTxt}}</button>
        </div>
      </div>
    </div>
  </div>
